/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum SortingMode {
    Disabled,
    Local,
    Remote,
}
